import React from 'react';
import QuestionnaireScreen from '../QuestionnaireScreen/QuestionnaireScreen'
import QuestionnaireStratPlan from '../../stacks/questionnaireStratPlan/QuestionnaireStratPlanAWS'

const QuestionnaireStratPlanScreen = props => {

  const dataStore = QuestionnaireStratPlan.getInstance()

  return (
    <QuestionnaireScreen
      product='StratPlan'
      layoutProduct='stratPlan'
      dataStore={dataStore}
      pathBase='questionnaire-stratplan'
      progresses='questionnaireStratPlan'
      home='/financial'
      {...props}
    />
  )
}

export default QuestionnaireStratPlanScreen